module.exports = __webpack_public_path__ + "static/media/Template_urgent_regular_national.cc31c1df.csv";